import { alpha, styled, Typography } from "@mui/material";
import { FlexBox } from "@/components/baseComponents/FlexBox";

export const StyledContainer = styled(FlexBox)(() => ({
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
}));

export const StyledTitleContainer = styled(FlexBox)(() => ({
  flexDirection: "row",
  alignItems: "center",
  gap: "8px",
}));

export const StyledTitleNumber = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "600",
  color: theme.palette.primary.main,
  lineHeight: "24px",
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "600",
  color: theme.palette.text.primary,
  lineHeight: "24px",
}));

export const StyledContentContainer = styled(FlexBox)(({ theme }) => ({
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "12px",
  width: "100%",
  backgroundColor: theme.palette.common.white,
  borderRadius: "12px",
  padding: "24px",
}));

export const StyledHint = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  fontWeight: theme.typography.subtitle2.fontWeight,
  lineHeight: theme.typography.body2.lineHeight,
  color: theme.palette.warning.dark,
}));

export const OptionButton = styled("button")<{ $isSelected: boolean }>(
  ({ theme, $isSelected }) => ({
    minWidth: "120px",
    padding: "4px 16px",
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
    ...($isSelected
      ? {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        }
      : {
          backgroundColor: theme.palette.common.white,
          color: theme.palette.primary.dark,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.48)}`,
          "&:hover": {
            backgroundColor: theme.palette.primary.lighter,
          },
        }),
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: theme.palette.common.white,
      },
    },
  })
);
